import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Dialog } from 'aura-react-components';
import { useTranslation } from 'react-i18next';
export const SessionTimeoutDialog = ({ open, remainingSeconds, onStaySignedIn, onSignOut, disableStaySignedIn = false, disableSignOut = false }) => {
    const { t } = useTranslation('app');
    const description = t('sessionTimeout.description', {
        seconds: remainingSeconds,
        defaultValue: 'For your security, you will be signed out in {{seconds}} seconds unless you stay signed in.'
    });
    const primaryLabel = t('sessionTimeout.staySignedIn', 'Stay signed in');
    const secondaryLabel = t('sessionTimeout.signOut', 'Sign out now');
    const handleDialogClose = () => {
        // Intentionally a no-op: clicking outside or pressing Escape
        // should not log the user out or refresh the session.
    };
    return (_jsx(Dialog, { id: "session-timeout-dialog", open: open, title: t('sessionTimeout.title', 'Your session is about to expire'), onClose: handleDialogClose, primaryAction: {
            label: primaryLabel,
            handler: onStaySignedIn,
            disabled: disableStaySignedIn,
            buttonPropOverrides: {
                'aria-label': primaryLabel,
                sx: {
                    borderRadius: '999px',
                    textTransform: 'none',
                    px: 3
                }
            }
        }, secondaryAction: {
            label: secondaryLabel,
            handler: onSignOut,
            disabled: disableSignOut,
            buttonPropOverrides: {
                'aria-label': secondaryLabel,
                sx: {
                    borderRadius: '999px',
                    textTransform: 'none',
                    px: 3
                }
            }
        }, showCloseButton: false, showCloseIcon: false, reverseButtonOrder: true, muiDialogPropOverrides: {
            PaperProps: {
                sx: {
                    borderRadius: '24px'
                }
            }
        }, children: _jsx(Typography, { children: description }) }));
};
